module.exports = __webpack_public_path__ + "img/pr-18.7e60a7ab.png";